import { render, staticRenderFns } from "./StepResumo.vue?vue&type=template&id=12490a16&scoped=true"
import script from "./StepResumo.vue?vue&type=script&lang=js"
export * from "./StepResumo.vue?vue&type=script&lang=js"
import style0 from "./StepResumo.vue?vue&type=style&index=0&id=12490a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12490a16",
  null
  
)

export default component.exports